import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { translationConstants, viewPathConstants } from "../../../../constants";

const AlreadyHaveAAccount = (props) => {
  const {
    handlealreadyHaveAccount,
    handleRegisterasCenter,
  } = props
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="AlreadyHaveCom">
      <hr className="HorizentalLIne" />
      <p className="haveAccountPara">
        {t(translationConstants.alreadyHaveAccount)}{" "}
        <span
          onClick={() => {
            if (handlealreadyHaveAccount) {
              handlealreadyHaveAccount();
            } else {
              navigate(viewPathConstants.DEFAULT_PATH);
            }
          }}
        >
          {t(translationConstants.loginHere)}
        </span>
      </p>
    </div>
  );
};

export default AlreadyHaveAAccount;
